<template>
    <v-card :loading="loading" mx-4 min-height="500">
        <template slot="progress">
            <v-overlay absolute class="d-flex flex-column text-center">
                <div>
                    <v-progress-circular size="250" width="10" color="primary" indeterminate>
                        <span>In curs de incarcare...</span>
                    </v-progress-circular>
                </div>
            </v-overlay>
        </template>
        <v-tabs
            v-model="tab"
            background-color="primary"
            dark
        >
            <v-tab key="general">
                Informatii generale
            </v-tab>
            <v-tab key="extra">
                Informatii vehicule proprii
            </v-tab>
            <v-tab v-if="!_.isNil(form.id)" key="file">
                Fisa echipamentului
            </v-tab>
            <v-tab v-if="!_.isNil(form.id)" key="comments">
                Note
            </v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab">
            <v-tab-item key="general">
                <v-card class="px-4 py-4" flat>
                    <v-autocomplete
                        v-model="form.customer_id"
                        :items="customers"
                        item-value="id"
                        item-text="name"
                        v-validate="'required'"
                        :error-messages="errorMessages('customer_id')"
                        :class="{ 'error--text': hasErrors('customer_id') }"
                        class="primary--text"
                        name="customer_id"
                        label="Client / Proprietar"
                        data-vv-as="Client / Proprietar"
                        data-vv-name="customer_id"
                    />
                    <v-text-field
                        v-model="form.brand"
                        v-validate="'required'"
                        :error-messages="errorMessages('brand')"
                        :class="{ 'error--text': hasErrors('brand') }"
                        class="primary--text"
                        name="brand"
                        label="Marca"
                        data-vv-as="Marca"
                        data-vv-name="brand"
                        counter="255"
                    />
                    <v-text-field
                        v-model="form.model"
                        v-validate="'required'"
                        :error-messages="errorMessages('model')"
                        :class="{ 'error--text': hasErrors('model') }"
                        class="primary--text"
                        name="model"
                        label="Model"
                        data-vv-as="Model"
                        data-vv-name="model"
                        counter="255"
                    />
                    <v-text-field
                        v-model="form.chassis"
                        :error-messages="errorMessages('chassis')"
                        :class="{ 'error--text': hasErrors('chassis') }"
                        class="primary--text"
                        name="chassis"
                        label="Serie sasiu"
                        data-vv-as="Serie sasiu"
                        data-vv-name="chassis"
                        counter="255"
                    />
                    <v-text-field
                        v-model="form.engine"
                        :error-messages="errorMessages('engine')"
                        :class="{ 'error--text': hasErrors('engine') }"
                        class="primary--text"
                        name="engine"
                        label="Serie motor"
                        data-vv-as="Serie motor"
                        data-vv-name="engine"
                        counter="255"
                    />
                    <v-text-field
                        v-model="form.vehicle_plate"
                        :error-messages="errorMessages('vehicle_plate')"
                        :class="{ 'error--text': hasErrors('vehicle_plate') }"
                        class="primary--text"
                        name="vehicle_plate"
                        label="Numar inregistrare/inmatriculare"
                        data-vv-as="Numar inregistrare/inmatriculare"
                        data-vv-name="vehicle_plate"
                        counter="255"
                    />
                    <v-textarea
                        v-model="form.data.remarks"
                        :error-messages="errorMessages('data.remarks')"
                        :class="{ 'error--text': hasErrors('data.remarks') }"
                        class="primary--text"
                        name="data.remarks"
                        label="Observatii"
                        data-vv-as="Observatii"
                        data-vv-name="data.remarks"
                    />

                    <v-btn
                        :loading="form.busy"
                        :disabled="errors.any() || form.busy"
                        block
                        color="success"
                        @click="submit()"
                    >
                        Salveaza
                        <v-icon right>
                            save
                        </v-icon>
                    </v-btn>
                </v-card>
            </v-tab-item>

            <v-tab-item key="extra">
                <v-card class="px-4 py-4" flat>
                    <v-text-field
                        type="number"
                        v-model="form.data.year"
                        :error-messages="errorMessages('year')"
                        :class="{ 'error--text': hasErrors('year') }"
                        class="primary--text"
                        name="year"
                        label="An fabricatie"
                        data-vv-as="An fabricatie"
                        data-vv-name="year"
                        counter="255"
                    />
                    <v-select
                        :items="fuelItems"
                        v-model.lazy="form.data.fuel"
                        label="Combustibil"
                        data-vv-as="Combustibil"
                        :error-messages="errorMessages('fuel')"
                        :class="{ 'error--text': hasErrors('fuel') }"
                        class="primary--text"
                        name="fuel"
                        data-vv-name="fuel"
                    ></v-select>
                    <v-text-field
                        type="number"
                        v-model="form.data.avg_consumption"
                        :error-messages="errorMessages('avg_consumption')"
                        :class="{ 'error--text': hasErrors('avg_consumption') }"
                        class="primary--text"
                        name="avg_consumption"
                        label="Consum mediu"
                        data-vv-as="Consum mediu"
                        data-vv-name="avg_consumption"
                        counter="255"
                    />
                    <v-menu
                        ref="entryDateMenu"
                        v-model="entryDateMenu"
                        :return-value.sync="form.data.entry_date"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                v-model="form.data.entry_date"
                                label="Data achizitiei"
                                data-vv-as="Data achizitiei"
                                prepend-icon="mdi-calendar"
                                readonly
                                :error-messages="errorMessages('data.entry_date')"
                                :class="{ 'error--text': hasErrors('data.entry_date') }"
                                class="primary--text"
                                data-vv-name="data.entry_date"
                                v-bind="attrs"
                                v-on="on"
                            ></v-text-field>
                        </template>
                        <v-date-picker
                            v-model="form.data.entry_date"
                            no-title
                            scrollable
                        >
                            <v-spacer></v-spacer>
                            <v-btn
                                text
                                color="primary"
                                @click="entryDateMenu = false"
                            >
                                Iesire
                            </v-btn>
                            <v-btn
                                text
                                color="warning"
                                @click="$refs.entryDateMenu.save(null)"
                            >
                                Anulare
                            </v-btn>
                            <v-btn
                                text
                                color="primary"
                                @click="$refs.entryDateMenu.save(form.data.entry_date)"
                            >
                                OK
                            </v-btn>
                        </v-date-picker>
                    </v-menu>

                    <v-text-field
                        type="number"
                        v-model="form.data.entry_km"
                        :error-messages="errorMessages('data.entry_km')"
                        :class="{ 'error--text': hasErrors('data.entry_km') }"
                        class="primary--text"
                        name="data.entry_km"
                        label="Nr. ore / km achizitie"
                        data-vv-as="Nr. ore / km achizitie"
                        data-vv-name="data.entry_km"
                        counter="255"
                    />

                    <v-text-field
                        type="number"
                        v-model="form.data.entry_price"
                        :error-messages="errorMessages('data.entry_price')"
                        :class="{ 'error--text': hasErrors('data.entry_price') }"
                        class="primary--text"
                        name="data.entry_price"
                        label="Pret achizitie"
                        data-vv-as="Pret achizitie"
                        data-vv-name="data.entry_price"
                        counter="255"
                    />

                    <v-subheader>Scoatere din uz - se completeaza in caz de vanzare/casare</v-subheader>
                    <v-menu
                        ref="endDateMenu"
                        v-model="endDateMenu"
                        :return-value.sync="form.end_date"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                v-model="form.end_date"
                                prepend-icon="mdi-calendar"
                                label="Data scoaterii din uz"
                                data-vv-as="Data scoaterii din uz"
                                readonly
                                :error-messages="errorMessages('end_date')"
                                :class="{ 'error--text': hasErrors('end_date') }"
                                class="primary--text"
                                data-vv-name="end_date"
                                v-bind="attrs"
                                v-on="on"
                            ></v-text-field>
                        </template>
                        <v-date-picker
                            v-model="form.end_date"
                            no-title
                            scrollable
                        >
                            <v-spacer></v-spacer>
                            <v-btn
                                text
                                color="primary"
                                @click="endDateMenu = false"
                            >
                                Iesire
                            </v-btn>
                            <v-btn
                                text
                                color="warning"
                                @click="$refs.endDateMenu.save(null)"
                            >
                                Anulare
                            </v-btn>
                            <v-btn
                                text
                                color="primary"
                                @click="$refs.endDateMenu.save(form.end_date)"
                            >
                                OK
                            </v-btn>
                        </v-date-picker>
                    </v-menu>

                    <v-text-field
                        type="number"
                        v-model="form.end_km"
                        :error-messages="errorMessages('end_km')"
                        :class="{ 'error--text': hasErrors('end_km') }"
                        class="primary--text"
                        name="end_km"
                        label="Rulaj in momentul scoaterii din uz"
                        data-vv-as="Rulaj in momentul scoaterii din uz"
                        data-vv-name="end_km"
                        counter="255"
                    />
                </v-card>
            </v-tab-item>

            <v-tab-item v-if="!_.isNil(form.id)" key="file">
                <offers-component :equipment-id="form.id"></offers-component>
            </v-tab-item>

            <v-tab-item v-if="!_.isNil(form.id)" key="comments">
                <comments-component :id="form.id" type="App\Models\Equipment"></comments-component>
            </v-tab-item>
        </v-tabs-items>
    </v-card>
</template>

<script>
    import OffersComponent from 'Components/equipments/OffersComponent'
    import CommentsComponent from 'Components/common/CommentsComponent'
    import validationError from "Mixins/validation-error";
    import {Form} from "vform";

    export default {
        mixins: [validationError],
        components: {
            OffersComponent,
            CommentsComponent
        },
        props: {
            id: {
                type: [Number, String],
                required: false
            }
        },
        data: () => ({
            tab: 'general',
            loading: false,
            customers: [],
            entryDateMenu: false,
            endDateMenu: false,
            /* Always Declare Your Form Object */
            form: new Form({
                id: null,
                customer_id: null,
                brand: null,
                model: null,
                chassis: null,
                engine: null,
                vehicle_plate: null,
                end_km: null,
                end_date: null,
                data: {
                    remarks: null,
                    year: null,
                    fuel: null,
                    avg_consumption: null,
                    entry_km: null,
                    entry_date: null,
                    entry_price: null,
                },
            }),
        }),
        computed: {
            fuelItems () {
                return Object.keys(this.Static.fuelTypes)
                    .map((item) => {
                        return {
                            value: item,
                            text: this.Static.fuelTypes[item]
                        }
                    })
            },
        },
        async mounted() {
            const {meta, data} = await this.$db.Customer
                .select('id', 'name')
                .limit(10000)
                .get()
            this.customers = data
            if(this.id) {
                await this.loadResource()
            }
        },
        methods: {
            async loadResource() {
                let self = this;
                this.loading = true;

                let { data } = await this.$db.Equipment.find(this.id)
                self.form = new Form(data)
                this.loading = false
            },
            async submit() {
                let self = this;
                this.$validator.validateAll().then(result => {
                    if (result) {
                        // eslint-disable-next-line
                        self.createOrUpdate();
                    } else {
                        this.showError()
                    }
                });
            },
            async createOrUpdate() {
                let self = this;
                self.form.busy = true;

                var customer = new this.$db.Customer({id: self.form.customer_id})
                var model = new this.$db.Equipment(self.form).for(customer);
                if (this.id) {
                    model.id = this.id
                }

                model.save()
                    .then(response => {
                        self.$validator.reset();
                        this.showSuccess();
                        self.$nextTick(() => self.$router.push({name: "equipments-index"}));
                    })
                    .catch(errors => {
                        self.form.errors.set(this.form.extractErrors(errors.response))
                        this.showError()
                    }).finally(() => {
                    self.form.busy = false;
                });
            }
        }
    };
</script>
